import {
	Form,
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { INPUT_HEIGHTS, BORDER_OPACITY } from "@/components/ui/constants";
import { Eye, EyeOff } from "lucide-react";
import Image from "next/image";
import { useState, useId } from "react";
import { useFormContext } from "react-hook-form";

type PasswordInputProps = {
	name: string;
	label: string;
	placeholder?: string;
	value?: string;
	disabled?: boolean;
	intent?: "column" | "inlined";
	autoComplete?: string;
};

const ICON_COLOR = "var(--color-brand-primary)";

function PasswordInput({ name, label, placeholder, value, disabled, intent, autoComplete }: PasswordInputProps) {
	const { control } = useFormContext();
	const [visible, setVisible] = useState<boolean>(false);
	const inputId = useId();
	return (
		<FormField
			control={control}
			name={name}
			render={({ field }) => (
				<FormItem intent={intent} className="relative">
					{label && label.length > 0 && <FormLabel intent={intent} htmlFor={inputId} className="font-semibold">{label}</FormLabel>}
					<FormControl>
						<div className="relative flex items-center justify-end" style={{ minHeight: '44px', height: '44px' }}>
							<Input
								id={inputId}
								className={`shrink-0 ${BORDER_OPACITY.visible}`}
								style={{ minHeight: '44px', height: '44px', boxSizing: 'border-box' }}
								disabled={disabled}
								placeholder={placeholder}
								type={visible ? "text" : "password"}
								{...field}
								// Ensure value is always a string to prevent uncontrolled->controlled warning
								value={field.value ?? ""}
								autoComplete={autoComplete || "current-password"}
							/>
							<span
								onClick={() => setVisible(!visible)}
								className="absolute flex cursor-pointer p-3"
							>
								{visible ? (
									<Eye stroke={ICON_COLOR} size={16} strokeWidth="2" />
								) : (
									<EyeOff stroke={ICON_COLOR} size={16} strokeWidth="2" />
								)}
							</span>
						</div>
					</FormControl>
					<FormMessage intent={intent} />
				</FormItem>
			)}
		/>
	);
}

export default PasswordInput;
